// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__34yJo","description":"styles_description__3qYOp","content":"styles_content__NbJvJ","item":"styles_item__1nUlB","icon":"styles_icon__2G681"};